import React from "react";
import PropTypes from "prop-types";
import { stylesSx } from "common/components/NavBar/styles.js";
import { Badge, Box, Button, IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const NotLoggedUserMenu = ({ setOpenLogInForm, setOpenSignInForm }) => {
    const { boxDisplayStyle, boxFlexStyle } = stylesSx;

    return (
        <>
            <Box sx={boxFlexStyle} />
            <Box sx={boxDisplayStyle}>
                <Button
                    variant="outlined"
                    sx={{
                        color: "white",
                        marginBottom: { xs: "10px", md: "0px" },
                    }}
                    startIcon={<PersonIcon />}
                    onClick={() => {
                        setOpenLogInForm(true);
                        setOpenSignInForm(false);
                    }}
                >
                    Iniciar sesión
                </Button>
                <Button
                    variant="outlined"
                    sx={{ color: "white", marginLeft: "10px" }}
                    onClick={() => {
                        setOpenSignInForm(true);
                        setOpenLogInForm(false);
                    }}
                >
                    Registrarse
                </Button>
            </Box>
        </>
    );
};

NotLoggedUserMenu.propTypes = {
    children: PropTypes.node,
    // index: PropTypes.number.isRequired,
    // value: PropTypes.number.isRequired,
};

export default NotLoggedUserMenu;
